import styled from 'styled-components';
import JobReviewFilters from './component';

export default styled(JobReviewFilters)``;
